import React from 'react';
import { IconProps } from '.';

const SvgScissorsFillRounded = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='m11.998 14.328 5.542 8.164.323-.25c.548-.425.952-.964 1.166-1.555a3.441 3.441 0 0 0-.323-3.035l-4.481-6.612 1.321-1.94c.782.369 1.664.453 2.52.24 1.736-.434 2.96-2.078 2.934-3.939-.04-1.86-1.295-3.428-3.06-3.81-1.667-.366-3.342.426-4.166 1.977a4.106 4.106 0 0 0-.17 3.445L11.99 9.368l-1.594-2.343a3.948 3.948 0 0 0 .288-1.736 3.963 3.963 0 0 0-1.228-2.73 3.73 3.73 0 0 0-2.818-1.053c-1.05.06-2.01.547-2.701 1.375A4.015 4.015 0 0 0 3 5.501v.141a3.983 3.983 0 0 0 1.31 2.83 3.73 3.73 0 0 0 4.143.627l1.314 1.933-4.575 6.757-.023.036a3.578 3.578 0 0 0 .07 3.45c.233.377.528.698.898.98l.322.245 5.535-8.172h.004ZM6.852 4.038c.77 0 1.395.648 1.395 1.444 0 .795-.626 1.443-1.395 1.443-.77 0-1.396-.648-1.396-1.443 0-.796.626-1.443 1.396-1.443Zm10.292 2.887c-.77 0-1.395-.648-1.395-1.443 0-.796.625-1.443 1.395-1.443s1.395.647 1.395 1.443c0 .795-.626 1.443-1.395 1.443Z'
      />
    </svg>
  );
};

export default SvgScissorsFillRounded;
